// @flow

import React from 'react'
import { applyStylingHoc, type StyleOuterProps, type StyleProps } from '@fcse/tsbob/dist/lib/styling'
import CaseTeaser from '../CaseTeaser'
import baseStyles from './CaseFunctionalities.scss'

type Props = {
  ...StyleProps,
  inversed?: boolean,
  functionalities: Array<Object>
}

const CaseFunctionalities = ({ inversed, styles, functionalities }: Props) => {
  return (
    <div className={styles.root}>
      <div className={styles.list}>
        {functionalities.map((item, i) => {
          return (
            <div key={'caseFunct' + i} className={styles.listItem}>
              <CaseTeaser
                title={item.title}
                list={item.list}
                img={item.img}
                styles={styles.teaser}
                reversed={inversed ? i % 2 === 0 : i % 2 !== 0}
                imgWide={item.imgWide}
              />
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default applyStylingHoc(baseStyles)<$Diff<Props, StyleProps> & StyleOuterProps, Function>(CaseFunctionalities)
